import React from 'react'

const TextArea = ({ rows, cols, maxlength, placeholder, onChange, value, className }) => (
  <textarea value={value} rows={rows} maxlength={maxlength} placeholder={placeholder} onChange={onChange} className={`p-2.5 w-full text-sm text-gray-900 bg-gray-50 ${className}`}></textarea>
)

export default TextArea
